const { createElem } = require('./helperFunctions');

const addTitleContainer = () => {
    const body = document.querySelector('body');

    if (!body.classList.contains('single-page')) {
        return;
    }

    const itemType = document.querySelector('#page-type-identifier').getAttribute('data-item-type');
    const levelThreeContainer = document.querySelector('.level-three');
    const entryWrapper = document.querySelector('.entry-wrapper');
    const title = document.querySelector('.entry-wrapper > h1');
    const titleContainer = createElem('div', { class: 'titleContainer' });

    titleContainer.appendChild(title);

    if (itemType === 'uberflip') {
        levelThreeContainer.insertBefore(titleContainer, levelThreeContainer.childNodes[0]);
    } else {
        entryWrapper.insertBefore(titleContainer, entryWrapper.childNodes[0]);
    }
};

export { addTitleContainer };


// WEBPACK FOOTER //
// ./scriptPartials/handleItemLevelTitle.js